// extracted by mini-css-extract-plugin
export default {"countdown":"H2-z","srOnly":"I2-z"};